import { render, staticRenderFns } from "./UCIrvineChem51LCLabReport4DiscussionConclusion.vue?vue&type=template&id=1e22b5c5&scoped=true&"
import script from "./UCIrvineChem51LCLabReport4DiscussionConclusion.vue?vue&type=script&lang=ts&"
export * from "./UCIrvineChem51LCLabReport4DiscussionConclusion.vue?vue&type=script&lang=ts&"
import style0 from "./UCIrvineChem51LCLabReport4DiscussionConclusion.vue?vue&type=style&index=0&id=1e22b5c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e22b5c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VForm,VRow})
